import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttachLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "M 9.6503906,2.25 C 6.6681836,2.25 4.25,4.6681836 4.25,7.6503906 V 14 c 0,4.280196 3.4697943,7.75 7.75,7.75 4.280196,0 7.75,-3.469804 7.75,-7.75 V 4.8808594 c 0,-0.4142096 -0.3358,-0.75 -0.75,-0.75 -0.4142,0 -0.75,0.3357904 -0.75,0.75 V 14 c 0,3.451797 -2.798203,6.25 -6.25,6.25 C 8.5482135,20.25 5.75,17.451797 5.75,14 V 7.6503906 C 5.75,5.4966028 7.4966028,3.75 9.6503906,3.75 c 2.1537974,0 3.9003904,1.7466028 3.9003904,3.9003906 V 13.84375 c 0,0.882199 -0.716257,1.597656 -1.597656,1.597656 -0.882599,0 -1.597656,-0.715657 -1.597656,-1.597656 V 7.9980469 c 0,-0.4142096 -0.335801,-0.75 -0.7500002,-0.75 -0.4142096,0 -0.75,0.3357904 -0.75,0.75 V 13.84375 c -1e-7,1.709998 1.3862582,3.097656 3.0976562,3.097656 1.710598,0 3.097656,-1.387858 3.097656,-3.097656 V 7.6503906 C 15.050781,4.6681836 12.632588,2.25 9.6503906,2.25 Z"
	})]
});
export default SvgAttachLine;
